import React from 'react';
import { FooterStore } from './footer.mobx-store';
const FooterContext = /*#__PURE__*/React.createContext(null);
export const FooterContextProvider = ({
  clientProps,
  serverProps,
  limitedConsumptionTrial,
  children
}) => {
  const [context] = React.useState({
    footerStore: new FooterStore(serverProps, clientProps),
    limitedConsumptionTrial
  });
  React.useEffect(() => {
    if (clientProps) {
      context.footerStore.updateClientData(clientProps);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientProps]);
  React.useEffect(() => {
    context.footerStore.updateServerData(serverProps);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [serverProps]);
  return /*#__PURE__*/React.createElement(FooterContext.Provider, {
    value: context
  }, children);
};
export const useFooterContext = () => {
  const footerContext = React.useContext(FooterContext);
  if (!footerContext) {
    throw new Error('useFooterContext must be used within a FooterProvider.');
  }
  return footerContext;
};
//# sourceMappingURL=footer-context.js.map